import React from "react";

export const circle = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 128 128"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="64" cy="64" r="64" fill="currentColor"></circle>
    </svg>
  );
};
